import {Navigate, useLocation} from "react-router-dom";

const APP_BASE = "/lk";

function normalizeNextPath(path: string): string {
    if (!path) return "/";
    const raw = String(path).trim();
    if (!raw.startsWith("/")) return "/";
    if (raw === APP_BASE) return "/";
    if (raw.startsWith(`${APP_BASE}/`)) {
        return raw.slice(APP_BASE.length) || "/";
    }
    return raw;
}

export const ProtectedRoute = ({children}: any) => {
    const location = useLocation();

    const user = localStorage.getItem("user");
    if (!user) {
        const next = normalizeNextPath(`${location.pathname}${location.search}${location.hash}`);
        return <Navigate to={`/login?next=${encodeURIComponent(next)}`} replace />;
    }
    return children;
};